export default __webpack_public_path__ + "static/media/stationary_background.8e7ae73b.jpg";